import React from 'react';
import { Link } from 'react-router-dom';
export function About() {
  return <div className="bg-gray-50 min-h-screen pb-16" data-id="element-231">
      {/* Hero */}
      <section className="bg-white border-b border-gray-200" data-id="element-232">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center" data-id="element-233">
          <span className="text-xs font-semibold uppercase tracking-widest text-red-600" data-id="element-234">
            About Beach Shop
          </span>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-3 mb-4" data-id="element-235">
            Beachwear & accessories, made for the Maldivian sun
          </h1>
          <p className="text-gray-600 text-base sm:text-lg leading-relaxed" data-id="element-236">
            Beach Shop is a locally-owned retailer based in Malé, serving
            residents and visitors across the Maldives with thoughtfully chosen
            beachwear, accessories, and essentials for summer holidays. We're
            small, focused, and obsessive about quality — so you can spend less
            time shopping and more time in the water.
          </p>
        </div>
      </section>

      {/* About */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-237">
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-238">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-239">Our Story</h2>
          <div className="space-y-4 text-gray-600 leading-relaxed" data-id="element-240">
            <p data-id="element-241">
              Beach Shop started in 2018 with a single rack in a guesthouse on
              Maafushi. We noticed that visitors and locals alike were
              constantly searching for the simple things — a quality towel, a
              good pair of sandals, reef-safe sunscreen — but having to choose
              between overpriced resort boutiques and disappointing online
              orders.
            </p>
            <p data-id="element-242">
              Today, we operate from Malé with delivery across the country and a
              point-of-sale presence at select island shops. We've grown, but
              the mission hasn't changed: well-made beach essentials, fair
              prices, and a shopping experience that feels as easy as the lagoon
              outside your door.
            </p>
            <p data-id="element-243">
              Every product we carry is chosen with island life in mind — built
              for sun, sand, salt, and snorkeling adventures across our 1,192
              islands. We work directly with Maldivian artisans and producers
              wherever possible, and we never sell anything that damages our
              reefs.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-244">
        <div className="bg-red-50 border border-red-100 rounded-2xl p-8 text-center" data-id="element-245">
          <h2 className="text-xl font-bold text-gray-900 mb-2" data-id="element-246">
            Ready to shop?
          </h2>
          <p className="text-gray-600 mb-6" data-id="element-247">
            Browse our curated collection of beachwear, accessories, and
            souvenirs.
          </p>
          <Link to="/shop" className="inline-flex items-center px-6 py-3 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700 transition-colors" data-id="element-248">
            Browse Shop
          </Link>
        </div>
      </section>
    </div>;
}